module.exports = __webpack_public_path__ + "static/media/sdg1.b8fc51ca.png";